export const STATUS_DRAFT = "DRAFT";
export const STATUS_PENDING = "PENDING";
export const STATUS_SENT = "SENT";
export const STATUS_SENT_TO_BANK = "SENT_TO_BANK";
export const STATUS_COMPLETED = "COMPLETED";
export const STATUS_HOLDON = "HOLDON";
export const STATUS_REFUSED = "REFUSED";


export const DPA = "DPA";
export const CHECK = "CHECK";


export const TRANSACTIONS_STATUS = {
  [STATUS_DRAFT] : STATUS_DRAFT,
  [STATUS_PENDING] : STATUS_PENDING,
  [STATUS_COMPLETED] : STATUS_COMPLETED,
  [STATUS_SENT] : STATUS_SENT,
  [STATUS_SENT_TO_BANK] : STATUS_SENT_TO_BANK,
  [STATUS_REFUSED] : STATUS_REFUSED,
  [STATUS_HOLDON] : STATUS_HOLDON,
};

export const PAYMENT_METHODS = [
  DPA,
  CHECK,
];